module.exports = __webpack_public_path__ + "static/img/Middle-Park.197a634.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Middle-Park.jpg
// module id = 6Brk
// module chunks = 0